import { render } from "./NotFoundView.vue?vue&type=template&id=e40ac89c"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=e40ac89c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__